import COLORS from '@/constants/colors';
import { HELP_ORDER_WHATSAPP_LINK } from '@/utils/whatsappUtils';
import { HelpOutline } from '@mui/icons-material';
import { ListItemButton, Typography } from '@mui/material';
import Box from '@mui/material/Box';
export function HelperButton() {
  return (
    <ListItemButton
      component="a"
      href={HELP_ORDER_WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        marginBottom: '0px',
        px: '8px',
        paddingBottom: '0px',
      }}
    >
      <Box
        sx={{
          flexDirection: 'row',
          alignItems: 'center',
          display: 'flex',
          padding: '8px',
          margin: '0px',
          textDecoration: 'none',
          borderRadius: '10px',
          cursor: 'pointer',
        }}
      >
        <HelpOutline sx={{ color: COLORS.gray_500 }} />
        <Typography
          variant="body1"
          sx={{ fontSize: '12px', mx: '10px', color: COLORS.gray_3 }}
        >
          Ayuda
        </Typography>
      </Box>
    </ListItemButton>
  );
}
